// Values hand-synched with PortCall.Models.CoordinationCards.CoordinationCardStatuses class.
export enum CoordinationCardStatuses {
    Accepted      = 0,
    Acknowledged  = 10,
    Pending       = 20,
    Denied        = 30,
}



// WEBPACK FOOTER //
// ./data/models/CoordinationCardStatuses.ts